/**
 * Session interface
 * An interface for the Browser's Session Storage.
 */

/**
 * Invokes the setItem() method of the Session interface.
 * When passed a key name and value, will add that key to the session,
 * or update that key's value if it already exists.
 *
 * @param key A DOMString containing the name of the key you want to create/update.
 * @param value A DOMString containing the value you want to give the key you are creating/updating.
 *
 * @return {Void}
 */
export const setInSession = (key, value) => window.sessionStorage.setItem(key, value);

/**
 * Invokes the get() method of the Session interface.
 * When passed a key name, will return that key's value
 * or null if the key does not exist.
 *
 * @param key A DOMString containing the name of the key you want to retrieve the value of.
 * @return {DOMString} A DOMString containing the value of the key.
 * If the key does not exist, null is returned.
 */

export const getInSession = (key) => window.sessionStorage.getItem(key);

/**
 * Invokes the removeItem() method of the Session interface.
 * When passed a key name, will remove that key from the session
 * if it exists.
 *
 * If there is no item associated with the given key,
 * this method will do nothing.
 * @param key A DOMString containing the name of the key you want to remove.
 */
export const removeInSession = (key) => window.sessionStorage.removeItem(key);

/**
 * Invokes the clear() method of the Session interface.
 * When invoked, clears all stored keys.
 *
 * @return {undefined}
 */
export const clearSession = () => window.sessionStorage.clear();
